module.exports = __webpack_public_path__ + "img/37_01.dd237404.png";